<div class="d-flex align-items-center justify-content-end">
  <label class="mb-0 text-secondary font-weight-500">{{label}}
    <select class="form-control form-control-sm d-inline mx-2" 
            style="width: auto; border: 1px solid #dee2e6;" 
            [value]="pageSize"
            [disabled]="disabled"
            (change)="onPageSizeChange($event)">
      <option *ngFor="let option of pageSizeOptions" [value]="option">{{option}}</option>
    </select>
    {{suffix}}
  </label>
</div>
